import { render } from "./ListAllCourses.vue?vue&type=template&id=4d0c9550&scoped=true"
import script from "./ListAllCourses.vue?vue&type=script&lang=js"
export * from "./ListAllCourses.vue?vue&type=script&lang=js"

import "./ListAllCourses.vue?vue&type=style&index=0&id=4d0c9550&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0c9550"]])

export default __exports__